import React, { Component } from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';

import HistoryUtil from './components/common/historyUtil';
import SessionManager from './components/common/sessionManager';
import MobileSessionManager from './components/pages/mobile/mobileSessionManager';
import lsUtil from './components/common/lsUtil';
import { LoadingPage } from './components/common/loadingPage';
import AutoReload from './components/AutoReload';
import Install from './components/pages/Install';
import { getChannelBrandingFeatures } from './data/channels';

import 'react-select/dist/react-select.css';
// import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';

// APP_MAIN_STYLESHEET defaults to ./stylesheets/main.scss
// May be overridden at build time with REACT_APP_MAIN_STYLESHEET env var
// See config-overrides.js for magic
import 'APP_MAIN_STYLESHEET';

import AWS from 'aws-sdk';
import awsAppConfig from './components/aws/cognito/config.js';

window.AWS = AWS;
window.AWS.config.correctClockSkew = true;
window.AWS.config.update({ region: awsAppConfig.region });

export var validRedirectParams = [
	'/dashboard',
    '/snapshot',
	'/account',
	'/stats',
	'/trip',
	'/mobile',
	'/forgot-password',
	'/new-password',
	'/reset-password',
	'/support',
	'/create-account',
	'/verify-account',
    '/select-account',
	'/invitation',
	'/prime',
]

export default class App extends Component {

	constructor(props) {

		super(props);
		this.state = {
			logOfConsole: [],
			lang: ''
		};
		this.activeChannelClass = null;
		window.mainapp = this;
	}

    componentDidMount() {
        const theme = this.getCurrentTheme();
        this.applyTheme(theme);
    }

    getCurrentTheme = () => {
        let theme = lsUtil.getItem('raven.theme');

        if (!theme) {
            const channelBranding = getChannelBrandingFeatures(process.env.REACT_APP_FEATURE_SET);
            theme = channelBranding.theme_selection || 'light';
        }
        return theme;
    }

    applyTheme = (theme) => {
        if(!theme) return;

        const htmlElement = document.querySelector('html');

        const normalizedTheme = theme.toLowerCase();

        switch (normalizedTheme) {
            case 'light':
                htmlElement.classList.remove('dark-theme');
                break;
            case 'dark':
                htmlElement.classList.add('dark-theme');
                break;
            default:
                if (this.activeChannelClass) {
                    htmlElement.classList.remove(this.activeChannelClass);
                }
                htmlElement.classList.add(normalizedTheme);
                this.activeChannelClass = normalizedTheme;
                break;
        }
    }

	//
	// Renders each page in the app.
	// Router handles which component is loaded at what url.
	// Passes props to SessionManager so history can be navigated dynamically with HistoryUtil.
	//
	render() {

        const theme = this.getCurrentTheme();

        return (
            <BrowserRouter>
                <div>

                    <LoadingPage color="blue" />

                    <Route component={AutoReload} />

                    <Route exact path="*" render={props => {
                        HistoryUtil.setHistory(props.history) //must set history before want to use it anywhere
                        return null
                    }} />

                    <Switch>

                        <Route exact path="(/|)" render={props => {
                            return <Redirect exact path="/" to={"/en" + props.location.search} />
                        }} />

                        <Route exact path="/installation" component={Install} />
                        <Route exact path="/install" component={Install} />

                        <Route path={"(" + validRedirectParams.join("|") + ")"} render={(props) => {
                            return <Redirect to={"/en" + props.location.pathname + props.location.search} />
                        }} />

                        <Route path="/:lang/mobile" render={(props) => (
                            <MobileSessionManager {...props} theme={theme} applyTheme={this.applyTheme} />
                        )} />
                        <Route path="/mobile" render={ ({location}) => (
                            <Redirect to={`/en${location.pathname}${location.search}`} />
                        )} />
                        <Route path="/:lang" render={props => {
                            return (
                                <SessionManager {...props} theme={theme} applyTheme={this.applyTheme} />
                            );
                        }} />

                        <Route render={(props) => {
                            return <Redirect to={"/en"} />
                        }} />
                    </Switch>
                </div>
            </BrowserRouter>
        );
	}
}
